export default __webpack_public_path__ + "images/5667672347a073c2e286c72e3024f963-fence.svg";